import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';

// 重置样式
import { ResetStyle } from './style/reset';
// 全局样式
import { GlobalStyle } from './style/global';

// 国际化配置
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

ReactDOM.render(
    <Provider store={store}>
        <ResetStyle />
        <GlobalStyle />
        <ConfigProvider locale={zhCN}>
            <App />
        </ConfigProvider>
    </Provider>,
    document.getElementById('root')
);

console._log = (...params) => {
    let arrLog = [];
    params.forEach(item => {
        arrLog.push(JSON.parse(JSON.stringify(item)));
    });
    console.log(...arrLog);
};
